import { JSX } from "solid-js";
import { useWebStoreContext } from "~/context/webstore_context";
import { clientRepo } from "~/server/apis/client_repo";
import { useBrandl2WebstoreTelescopeContext as useContext } from "../context/brandl2_webstore_telescope_context";
import { SimulateParams } from "~/hooks/denominations_grid/useDenominationGridState";
import { DenominationsGridWebstoreTelescope } from "~/components/webstore_telescope/denominations_grid_telescope_webstore/denominations_grid_telescope_webstore";

/**
 * Denomination section wrapping the DenominationsGridV2 component
 * Note: CTA button is now integrated within DenominationsGridV2
 */
export function DenominationSection(): JSX.Element {
  const { brand, routeData, onClickGetThisCard, ctaState, setCtaState } =
    useContext();
  const { storeState } = useWebStoreContext();

  const simulateData = () => routeData().simulate;

  const denominationProps = {
    discountPercentage:
      simulateData()?.discountDetails?.totalDiscount?.percentage ?? 0,
    brand: brand(),
    isCoinsOnly: false, // Not using paymentSource from simulation
    allowRewardCoins: storeState.isLoggedIn, // Webstore allows coins for logged in users
    showHubbleCoinRewards:
      brand().rewardType === "POSTPAID" && storeState.isLoggedIn,
    coinsBalance: storeState.coins ?? 0,
    isRewardTypePostPaid: brand().rewardType === "POSTPAID",
    minAmount: brand().amountConditions.minAmount,
    maxAmount: brand().amountConditions.maxAmount,
    initialSimulationData: simulateData(),
    getMode: () => "hubble" as const,
    getClientId: () => undefined,
    simulateFunction: (params: SimulateParams) => {
      return clientRepo.simulate(params);
    },
    initiateOrder: onClickGetThisCard,
    ctaState: ctaState,
    setCtaState: setCtaState,
  };

  return <DenominationsGridWebstoreTelescope {...denominationProps} />;
}
